
import React, { useState, useEffect } from 'react';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { TextField, Typography, Button, Box, Card, Grid, TableBody } from "@mui/material";
import * as Yup from "yup";
import Divider from "@mui/material/Divider";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import _ from "lodash";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import "../../Myaccount/Myaccount.css";
import Checkbox from "@mui/material/Checkbox";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import axios from "../../../utils/fvAxios";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import ProjectEvaluationSection2 from '../../AdminDashboard/Vendor/ProjectEvaluations/ProjectEvaluationSection2';
import ProjectEvaluationSection1 from '../../AdminDashboard/Vendor/ProjectEvaluations/ProjectEvaluationsection1';
import ProjectEvaluationSection3 from '../../AdminDashboard/Vendor/ProjectEvaluations/ProjectEvaluationSection3';



export default function Evaluations(props) {
    return (
        <>
            <Card sx={{ paddingTop: "10px", paddingBottom: "12px" }}>
                <ProjectEvaluationSection1 data={props?.data} />
                <ProjectEvaluationSection2 data={props?.data?.vendorReviews} />
                <ProjectEvaluationSection3 data={props?.data?.localVendorReviewSection} />

                <Stack direction="row" sx={{ float: "right", marginRight: "10px" }} spacing={2}>
                    <Button className='mt-5' variant="contained" sx={{ textTransform: "capitalize", padding: "15px" }} onClick={props.OPEN}> Cancel</Button> {/*onClick={() => props.RatingTypeChange((p) => !p, '')}*/}
                    {/* <Button variant="contained"  sx={{ textTransform: "capitalize", padding: "15px", }}> Save</Button> */}
                </Stack>
            </Card>
        </>
    )
}
